<script>
  import { onDestroy } from "svelte";
  import { lang } from '../lib/stores';
  export let data = {};
  export let totalWords = 0;
  export let totalText = 0;

let selectedLang;
const unsubscribe = lang.subscribe((value) => selectedLang = value);
onDestroy(unsubscribe);

  $: data;
</script>

<section class="dirtyStats">
  <div class="p">
    <blockquote>
      <p>
        Devo restare sobrio, <em>cazzo</em> mene<br />
        Fumo e <em>cazzo</em> mene<br />
        Tieni e <em>cazzo</em> tene<br />
        E <em>minchia</em>, frate', come sto<br />
        E <em>minchia</em>, frate', come sto<br />
        E <em>minchia</em>, fra', come sto
      </p>
      <p><small>Cazzo Mene, Lunga Vita a Sto, 2017</small></p>
    </blockquote>
    <p>
      {#if selectedLang === 'it'}
        Come abbiamo visto, le parole utilizzate da Ghali sono <em class="data"
          >{new Intl.NumberFormat("it-IT").format(totalWords)}</em
        >. Le parolacce che siamo riusciti ad identificare sono invece
        <em class="data"
          >{new Intl.NumberFormat("it-IT").format(data?.terms?.count ?? 0)}</em
        >
        ovvero lo
        <em class="data"
          >{new Intl.NumberFormat("it-IT").format(
            (data?.terms?.count / totalWords) * 100,
          )}%</em
        >. Stiamo però contando solo le singole parole, non tutte le loro
        occorrenze. Prendendo invece tutta la lunghezza dei testi (<em
          class="data">{new Intl.NumberFormat("it-IT").format(totalText)}</em
        >
        parole), le parolacce (<em class="data"
          >{new Intl.NumberFormat("it-IT").format(data?.totalTerms)}</em
        >) sono il
        <em class="data"
          >{new Intl.NumberFormat("it-IT").format(
            (data?.totalTerms / totalWords) * 100,
          )}%</em
        >
        con un picco del
        <em class="data"
          >{new Intl.NumberFormat("it-IT").format(
            (data?.topSongs.count / data?.topSongs?.detail.length) * 100,
          )}%</em
        >
        (<em class="data"
          >{new Intl.NumberFormat("it-IT").format(data?.topSongs.count ?? 0)}</em
        >
        ripetizioni) nella canzone <em>{data?.topSongs.detail.title ?? ""}</em>
        contenuta nell'abum <em>{data?.topSongs.album.title ?? ""}</em> del {data
          ?.topSongs.album.year ?? ""}.<br />
        Vediamo ora quali sono queste parole e in che canzoni appaiono.
      {:else}
        As we have seen, the words used by Ghali are <em class="data"
        >{new Intl.NumberFormat("en-US").format(totalWords)}</em
      >. The swear words that we have managed to identify are instead
      <em class="data"
      >{new Intl.NumberFormat("en-US").format(data?.terms?.count ?? 0)}</em
    > 
        or
        <em class="data"
        >{new Intl.NumberFormat("en-US").format(
          (data?.terms?.count / totalWords) * 100,
        )}%</em
      >. However, we are only counting the single words, not all their occurrences.
        Taking instead the entire length of the lyrics (<em
        class="data">{new Intl.NumberFormat("en-US").format(totalText)}</em
      > 
        words), the swear words (<em class="data"
        >{new Intl.NumberFormat("en-US").format(data?.totalTerms)}</em
      >) are
      <em class="data"
      >{new Intl.NumberFormat("en-US").format(
        (data?.totalTerms / totalWords) * 100,
      )}%</em
    > 
        with a peak of
        <em class="data"
        >{new Intl.NumberFormat("en-US").format(
          (data?.topSongs.count / data?.topSongs?.detail.length) * 100,
        )}%</em
      > 
        (<em class="data"
        >{new Intl.NumberFormat("en-US").format(data?.topSongs.count ?? 0)}</em
      > 
        repetitions) in the song <em>{data?.topSongs.detail.title ?? ""}</em> 
        contained in the album <em>{data?.topSongs.album.title ?? ""}</em> of {data
          ?.topSongs.album.year ?? ""}. 
        Let's now see what these words are and in which songs they appear.
      {/if}
    </p>
    <blockquote>
      <p>
        <em>Ti rollo in un lenzuolo</em>, frate', e t'accendo dai piedi, uff<br
        />
        Dopo puzzi di candela spenta<br />
        Questa <em>merda</em> fa venire il mal di testa<br />
      </p>
      <p><small>Cacao, DNA, 2020</small></p>
    </blockquote>
  </div>
</section>

<style>
</style>
